<script>
    import { Meteor } from "meteor/meteor";
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";
    import { onMount } from "svelte";
    import MgmtApplicationsPage from "./mgmt/MgmtApplicationsPage.svelte";
    import MgmtInventoryPage from "./mgmt/MgmtInventoryPage.svelte";
    import MgmtLeadsPage from "./mgmt/MgmtLeadsPage.svelte";

    let { section = "inventory" } = $props();

    let isAdmin = $state(false);
    let loading = $state(true);
    let actionMessage = $state("");
    const activeSection = $derived(
        ["inventory", "leads", "applications"].includes(section)
            ? section
            : "inventory",
    );

    function navigateMgmtSection(targetSection) {
        FlowRouter.go(`/mgmt/${targetSection}`);
    }

    function setActionMessage(message) {
        actionMessage = message;
    }

    onMount(() => {
        Meteor.call("users.isSuperAdmin", (error, result) => {
            isAdmin = !error && Boolean(result);
            loading = false;
        });
    });
</script>

{#if loading}
    <p>Loading management dashboard...</p>
{:else if !isAdmin}
    <section>
        <h1>Access denied</h1>
        <p>This area is restricted to super-admin accounts.</p>
    </section>
{:else}
    <section>
        <h1>Management Dashboard</h1>
        <div class="tabs" aria-label="Management sections">
            <button
                class:active={activeSection === "inventory"}
                onclick={() => navigateMgmtSection("inventory")}
                >Inventory</button
            >
            <button
                class:active={activeSection === "leads"}
                onclick={() => navigateMgmtSection("leads")}>Leads</button
            >
            <button
                class:active={activeSection === "applications"}
                onclick={() => navigateMgmtSection("applications")}
                >Applications</button
            >
        </div>

        {#if actionMessage}<p class="success">{actionMessage}</p>{/if}

        {#if activeSection === "inventory"}
            <MgmtInventoryPage onActionMessage={setActionMessage} />
        {:else if activeSection === "leads"}
            <MgmtLeadsPage onActionMessage={setActionMessage} />
        {:else}
            <MgmtApplicationsPage onActionMessage={setActionMessage} />
        {/if}
    </section>
{/if}
